import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ErrorIcon = ({ message, className }) => {
  return (
    <div
      className={`cp-erroricon ${className}`}
      style={{ textAlign: "center" }}
    >
      <FontAwesomeIcon
        icon={["fal", "exclamation-circle"]}
        style={{ fontSize: "4em", color: "#d4b106" }}
      />
      <p>{message}</p>
    </div>
  );
};

ErrorIcon.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string
};

export default ErrorIcon;



// WEBPACK FOOTER //
// ./src/views/components/generic/error_icon/ErrorIcon.jsx